export default "__VITE_ASSET__BSkw9Zkq__"